<template>
  <div class="space-y-4 sm:space-y-6 w-full min-w-0">
    <!-- Test Payout Section -->
    <div class="rounded-2xl p-[1px] bg-[#213E52]/20 shadow-xl shadow-black/30 backdrop-blur-md">
      <div class="rounded-2xl bg-gradient-to-b from-[#101832]/70 to-[#080C19]/80 p-4 sm:p-6 glass-panel">
        <div class="flex items-start justify-between mb-4">
          <div>
            <h3
              class="bg-gradient-to-r from-[#B8DAFF] to-[#1A6ECA] bg-clip-text text-transparent
                     text-lg md:text-xl font-semibold"
              style="font-family: Inter, ui-sans-serif, system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial"
            >
              Test Payout
            </h3>
            <p class="text-white/40 text-xs mt-1"
               style="font-family: Inter, ui-sans-serif, system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial">
              Distribute USDT rewards to stakers
            </p>
          </div>
          <div class="px-2.5 py-1 rounded-lg bg-sky-500/10 border border-sky-400/20">
            <span class="text-sky-300 text-xs font-semibold">TESTING</span>
          </div>
        </div>

        <div class="space-y-3">
          <div class="rounded-xl p-[1px] bg-[#213E52]/40">
            <div class="rounded-xl bg-[#0a1628]/40 p-3 sm:p-4">
              <label class="block text-xs text-white/60 mb-2 font-medium">Payout Amount</label>
              <div class="flex items-center gap-2">
                <input
                  :value="payoutInput"
                  @input="$emit('update:payoutInput', $event.target.value)"
                  type="number"
                  min="0"
                  step="0.01"
                  placeholder="0.00"
                  class="flex-1 min-w-0 px-3 sm:px-4 py-3 rounded-lg bg-slate-900/70 border border-slate-700/50
                         text-slate-100 placeholder-slate-500 focus:outline-none focus:ring-2
                         focus:ring-sky-400/50 focus:border-sky-400/50 transition-all text-base font-medium"
                />
                <div class="flex items-center gap-1 sm:gap-1.5 px-2 sm:px-3 py-2 rounded-lg bg-slate-800/60 border border-slate-700/30 shrink-0">
                  <img :src="iconUSDT" alt="USDT" class="h-4 w-4 sm:h-5 sm:w-5 aspect-square object-contain" />
                  <span class="text-slate-300 text-xs sm:text-sm font-semibold">USDT</span>
                </div>
              </div>
            </div>
          </div>

          <button
            @click="$emit('testPayout')"
            class="btn-primary w-full"
            title="Runs a small test payout (uses the amount above)"
          >
            <span class="flex items-center justify-center gap-2">
              <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
              </svg>
              Execute Payout
            </span>
          </button>

          <div class="flex items-start gap-2 text-xs text-white/40 bg-slate-900/30 rounded-lg p-3 border border-slate-800/50">
            <svg class="w-4 h-4 shrink-0 mt-0.5 text-sky-400/60" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
            </svg>
            <span>Distributes USDT proportionally to all stakers based on their weighted shares</span>
          </div>
        </div>
      </div>
    </div>

    <!-- Claim Vested (Dev View with Refresh) -->
    <div class="rounded-2xl p-[1px] bg-[#213E52]/20 shadow-xl shadow-black/30 backdrop-blur-md">
      <div class="rounded-2xl bg-gradient-to-b from-[#101832]/70 to-[#080C19]/80 p-4 sm:p-6 glass-panel">
        <div class="flex items-start justify-between mb-4">
          <div>
            <h3
              class="bg-gradient-to-r from-[#B8DAFF] to-[#1A6ECA] bg-clip-text text-transparent
                     text-lg md:text-xl font-semibold"
              style="font-family: Inter, ui-sans-serif, system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial"
            >
              Claim Vested VRX
            </h3>
            <p class="text-white/40 text-xs mt-1"
               style="font-family: Inter, ui-sans-serif, system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial">
              Claim available vested tokens
            </p>
          </div>
          <button
            @click="$emit('refreshVestedInfo')"
            class="btn-refresh"
          >
            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"></path>
            </svg>
          </button>
        </div>

        <div class="space-y-3">
          <div class="rounded-xl p-[1px] bg-[#213E52]/60">
            <div class="rounded-xl bg-[#0a1628]/55 p-3 sm:p-4 flex items-center justify-between inner-glass-panel">
              <div>
                <div class="text-[10px] sm:text-xs text-slate-400 mb-1">Available to Claim</div>
                <div class="flex items-center gap-2">
                  <span class="text-sky-300 text-xl sm:text-2xl font-bold tabular-nums">
                    {{ vestedClaimableDisplay }}
                  </span>
                  <img :src="iconVRX" alt="VRX" class="h-6 w-6 aspect-square object-contain" />
                </div>
              </div>
            </div>
          </div>

          <button
            @click="$emit('testClaimVested')"
            :disabled="!account || vestedClaimable === 0n"
            :class="[
              'btn-primary w-full',
              (!account || vestedClaimable === 0n) ? 'btn-disabled' : ''
            ]"
            title="Claims any vested VRX available to the connected account"
          >
            <span class="flex items-center justify-center gap-2">
              <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4"></path>
              </svg>
              Claim Vested Tokens
            </span>
          </button>

          <div class="flex items-start gap-2 text-xs text-white/40 bg-slate-900/30 rounded-lg p-3 border border-slate-800/50">
            <svg class="w-4 h-4 shrink-0 mt-0.5 text-sky-400/60" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
            </svg>
            <span>Executes VRX.claimVested(). Tokens must pass cliff period to be claimable.</span>
          </div>
        </div>
      </div>
    </div>

    <!-- Send Vested Section -->
    <div class="rounded-2xl p-[1px] bg-[#213E52]/20 shadow-xl shadow-black/30 backdrop-blur-md">
      <div class="rounded-2xl bg-gradient-to-b from-[#101832]/70 to-[#080C19]/80 p-4 sm:p-6 glass-panel">
        <div class="flex items-start justify-between mb-4">
          <div>
            <h3
              class="bg-gradient-to-r from-[#B8DAFF] to-[#1A6ECA] bg-clip-text text-transparent
                     text-lg md:text-xl font-semibold"
              style="font-family: Inter, ui-sans-serif, system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial"
            >
              Send Vested Grant
            </h3>
            <p class="text-white/40 text-xs mt-1"
               style="font-family: Inter, ui-sans-serif, system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial">
              Create vested token grants with custom schedules
            </p>
          </div>
          <div class="px-2.5 py-1 rounded-lg bg-amber-500/10 border border-amber-400/20">
            <span class="text-amber-300 text-xs font-semibold">OWNER</span>
          </div>
        </div>

        <div class="space-y-3">
          <div class="rounded-xl p-[1px] bg-[#213E52]/40">
            <div class="rounded-xl bg-[#0a1628]/40 p-3 sm:p-4 space-y-3">
              <div>
                <label class="block text-xs text-white/60 mb-2 font-medium">Recipient Address</label>
                <input
                  :value="vestTo"
                  @input="$emit('update:vestTo', $event.target.value)"
                  placeholder="0x..."
                  class="w-full min-w-0 px-3 sm:px-4 py-3 rounded-lg bg-slate-900/70 border border-slate-700/50
                         text-slate-100 placeholder-slate-500 focus:outline-none focus:ring-2
                         focus:ring-sky-400/50 focus:border-sky-400/50 transition-all text-xs sm:text-sm font-mono"
                />
              </div>

              <div class="grid grid-cols-1 sm:grid-cols-3 gap-3">
                <div>
                  <label class="block text-xs text-white/60 mb-2 font-medium">Amount (VRX)</label>
                  <div class="flex items-center gap-1.5 sm:gap-2">
                    <input
                      :value="vestAmountInput"
                      @input="$emit('update:vestAmountInput', $event.target.value)"
                      type="number" min="0" step="0.0001" placeholder="0"
                      class="flex-1 min-w-0 px-2.5 sm:px-3 py-2.5 rounded-lg bg-slate-900/70 border border-slate-700/50
                             text-slate-100 placeholder-slate-500 focus:outline-none focus:ring-2
                             focus:ring-sky-400/50 focus:border-sky-400/50 transition-all text-sm"
                    />
                    <img :src="iconVRX" alt="VRX" class="h-4 w-4 sm:h-5 sm:w-5 aspect-square object-contain shrink-0" />
                  </div>
                </div>

                <div>
                  <label class="block text-xs text-white/60 mb-2 font-medium">Duration (days)</label>
                  <input
                    :value="vestLockDays"
                    @input="$emit('update:vestLockDays', $event.target.value)"
                    type="number" min="0" step="1" placeholder="90"
                    class="w-full min-w-0 px-2.5 sm:px-3 py-2.5 rounded-lg bg-slate-900/70 border border-slate-700/50
                           text-slate-100 placeholder-slate-500 focus:outline-none focus:ring-2
                           focus:ring-sky-400/50 focus:border-sky-400/50 transition-all text-sm"
                  />
                </div>

                <div>
                  <label class="block text-xs text-white/60 mb-2 font-medium">Cliff (days)</label>
                  <input
                    :value="vestCliffDays"
                    @input="$emit('update:vestCliffDays', $event.target.value)"
                    type="number" min="0" step="1" placeholder="30"
                    class="w-full min-w-0 px-2.5 sm:px-3 py-2.5 rounded-lg bg-slate-900/70 border border-slate-700/50
                           text-slate-100 placeholder-slate-500 focus:outline-none focus:ring-2
                           focus:ring-sky-400/50 focus:border-sky-400/50 transition-all text-sm"
                  />
                </div>
              </div>
            </div>
          </div>

          <button
            @click="$emit('testSendVested')"
            :disabled="!isValidAddress(vestTo) || Number(vestAmountInput) <= 0"
            :class="[
              'btn-primary w-full',
              (!isValidAddress(vestTo) || Number(vestAmountInput) <= 0) ? 'btn-disabled' : ''
            ]"
            title="Sends a vested VRX grant with lock + cliff"
          >
            <span class="flex items-center justify-center gap-2">
              <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 19l9 2-9-18-9 18 9-2zm0 0v-8"></path>
              </svg>
              Create Vesting Grant
            </span>
          </button>

          <div class="flex items-start gap-2 text-xs text-white/40 bg-slate-900/30 rounded-lg p-3 border border-slate-800/50">
            <svg class="w-4 h-4 shrink-0 mt-0.5 text-sky-400/60" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
            </svg>
            <span>Duration/cliff values in days (converted to seconds on-chain). Requires sufficient vesting pool balance. Owner-only.</span>
          </div>
        </div>
      </div>
    </div>

    <!-- Mint to Vesting Pool Section -->
    <div class="rounded-2xl p-[1px] bg-[#213E52]/20 shadow-xl shadow-black/30 backdrop-blur-md">
      <div class="rounded-2xl bg-gradient-to-b from-[#101832]/70 to-[#080C19]/80 p-4 sm:p-6 glass-panel">
        <div class="flex items-start justify-between mb-4">
          <div>
            <h3
              class="bg-gradient-to-r from-[#B8DAFF] to-[#1A6ECA] bg-clip-text text-transparent
                     text-lg md:text-xl font-semibold"
              style="font-family: Inter, ui-sans-serif, system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial"
            >
              Mint to Vesting Pool
            </h3>
            <p class="text-white/40 text-xs mt-1"
               style="font-family: Inter, ui-sans-serif, system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial">
              Fund the vesting pool for creating grants
            </p>
          </div>
          <div class="flex items-center gap-2">
            <div class="px-2.5 py-1 rounded-lg bg-amber-500/10 border border-amber-400/20">
              <span class="text-amber-300 text-xs font-semibold">OWNER</span>
            </div>
            <button
              @click="$emit('refreshVestingPool')"
              class="btn-refresh"
            >
              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"></path>
              </svg>
            </button>
          </div>
        </div>

        <div class="space-y-3">
          <div class="rounded-xl p-[1px] bg-[#213E52]/60">
            <div class="rounded-xl bg-[#0a1628]/55 p-3 sm:p-4 flex items-center justify-between inner-glass-panel">
              <div>
                <div class="text-[10px] sm:text-xs text-slate-400 mb-1">Available Pool Balance</div>
                <div class="flex items-center gap-2">
                  <span class="text-emerald-300 text-xl sm:text-2xl font-bold tabular-nums">
                    {{ vestingPoolAvailableDisplay }}
                  </span>
                  <img :src="iconVRX" alt="VRX" class="h-6 w-6 aspect-square object-contain" />
                </div>
              </div>
            </div>
          </div>

          <div class="rounded-xl p-[1px] bg-[#213E52]/40">
            <div class="rounded-xl bg-[#0a1628]/40 p-3 sm:p-4">
              <label class="block text-xs text-white/60 mb-2 font-medium">Amount to Mint</label>
              <div class="flex items-center gap-2">
                <input
                  :value="mintPoolAmountInput"
                  @input="$emit('update:mintPoolAmountInput', $event.target.value)"
                  type="number" min="0" step="0.0001" placeholder="0"
                  class="flex-1 min-w-0 px-3 sm:px-4 py-3 rounded-lg bg-slate-900/70 border border-slate-700/50
                         text-slate-100 placeholder-slate-500 focus:outline-none focus:ring-2
                         focus:ring-sky-400/50 focus:border-sky-400/50 transition-all text-base font-medium"
                />
                <div class="flex items-center gap-1 sm:gap-1.5 px-2 sm:px-3 py-2 rounded-lg bg-slate-800/60 border border-slate-700/30 shrink-0">
                  <img :src="iconVRX" alt="VRX" class="h-4 w-4 sm:h-5 sm:w-5 aspect-square object-contain" />
                  <span class="text-slate-300 text-xs sm:text-sm font-semibold">VRX</span>
                </div>
              </div>
            </div>
          </div>

          <button
            @click="$emit('testMintToVestingPool')"
            :disabled="Number(mintPoolAmountInput) <= 0"
            :class="[
              'btn-primary w-full',
              Number(mintPoolAmountInput) <= 0 ? 'btn-disabled' : ''
            ]"
            title="Owner-only: mints VRX to the vesting pool (held by the VRX contract)"
          >
            <span class="flex items-center justify-center gap-2">
              <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6v6m0 0v6m0-6h6m-6 0H6"></path>
              </svg>
              Mint to Vesting Pool
            </span>
          </button>

          <div class="flex items-start gap-2 text-xs text-white/40 bg-slate-900/30 rounded-lg p-3 border border-slate-800/50">
            <svg class="w-4 h-4 shrink-0 mt-0.5 text-sky-400/60" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
            </svg>
            <span>Mints new VRX tokens to the vesting pool. These tokens become reserved when creating grants. Owner-only.</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ethers } from 'ethers'
import iconVRX from '../assets/VRX.png'
import iconUSDT from '../assets/USDT_Logo.png'

defineProps({
  account: String,
  payoutInput: [String, Number],
  vestedClaimable: [String, Number, Object],
  vestedClaimableDisplay: String,
  vestTo: String,
  vestAmountInput: [String, Number],
  vestLockDays: [String, Number],
  vestCliffDays: [String, Number],
  mintPoolAmountInput: [String, Number],
  vestingPoolAvailableDisplay: String,
})

defineEmits([
  'update:payoutInput',
  'testPayout',
  'refreshVestedInfo',
  'testClaimVested',
  'update:vestTo',
  'update:vestAmountInput',
  'update:vestLockDays',
  'update:vestCliffDays',
  'testSendVested',
  'update:mintPoolAmountInput',
  'refreshVestingPool',
  'testMintToVestingPool'
])

const isValidAddress = (addr) => {
  if (!addr) return false
  return ethers.isAddress(addr)
}
</script>

<style scoped>
/* Glass Panel Effect */
.glass-panel {
  backdrop-filter: blur(20px) saturate(180%);
  -webkit-backdrop-filter: blur(20px) saturate(180%);
  border: 1px solid rgba(255, 255, 255, 0.08);
}

.inner-glass-panel {
  backdrop-filter: blur(10px) saturate(150%);
  -webkit-backdrop-filter: blur(10px) saturate(150%);
  border: 1px solid rgba(255, 255, 255, 0.05);
}

/* Primary Button */
.btn-primary {
  @apply px-4 py-3 rounded-xl text-white font-semibold transition-all duration-200;
  background: linear-gradient(135deg, #0ea5e9 0%, #3b82f6 100%);
  box-shadow: 
    inset 0 1px 1px 0 rgba(255, 255, 255, 0.2), 
    inset 0 -1px 2px 0 rgba(0, 0, 0, 0.1),
    0 4px 16px rgba(14, 165, 233, 0.3);
}

.btn-primary:hover {
  background: linear-gradient(135deg, #38bdf8 0%, #60a5fa 100%);
  box-shadow: 
    inset 0 1px 1px 0 rgba(255, 255, 255, 0.25), 
    inset 0 -1px 2px 0 rgba(0, 0, 0, 0.1),
    0 6px 24px rgba(14, 165, 233, 0.4);
  transform: translateY(-2px);
}

.btn-primary:active {
  transform: translateY(0);
  box-shadow: 
    inset 0 1px 1px 0 rgba(255, 255, 255, 0.15), 
    inset 0 -1px 2px 0 rgba(0, 0, 0, 0.1),
    0 2px 8px rgba(14, 165, 233, 0.2);
}

/* Refresh Button */
.btn-refresh {
  @apply p-2 rounded-lg text-sky-300 bg-sky-500/10 border border-sky-400/20
         hover:bg-sky-500/20 hover:border-sky-400/30 focus:outline-none
         transition-all duration-200;
}

.btn-refresh:hover {
  transform: scale(1.05);
}

.btn-refresh:active {
  transform: scale(0.95);
}

/* Disabled Button State */
.btn-disabled {
  @apply opacity-40 cursor-not-allowed;
  pointer-events: none;
  filter: grayscale(0.5);
  background: linear-gradient(135deg, #334155 0%, #475569 100%);
  box-shadow: none;
}

.btn-disabled:hover {
  transform: none;
  box-shadow: none;
}

/* Input Focus Effects */
input:focus {
  box-shadow: 0 0 0 3px rgba(56, 189, 248, 0.15);
}

/* Mobile Responsiveness */
@media (max-width: 640px) {
  .btn-primary {
    @apply px-3 py-2.5 text-sm;
  }
  
  .btn-refresh {
    @apply p-1.5;
  }
  
  .btn-refresh svg {
    @apply w-3.5 h-3.5;
  }
}
</style>

